import { getTestIds } from 'seagull/utils/TestIds';
export const editClientModalTextsPath = 'components.editClientModal';
export const CLIENT_DETAILS_FORM_TEST_ID = 'edit-client-details';
export const GetEditClientModalTID = (parentTestId)=>getTestIds(parentTestId);
